
// constants as defined in RevoXef’s App\Models\Orders\Order
const NORMAL = 0
const CHECK_PRINTED = 1
// const REOPENED = 2
const PENDING_NOTE = 3
// const CONTENT_READY = 4
// const KIOSK_CALL_WAITER = 5
// const KIOSK_WAITING_BILL = 6
// const PAID_OUTSIDE = 7
const REFUNDED = 12
const PARTIALLY_REFUNDED = 13
// const MERGED_FROM_ONLINE = 15
const SHOULD_BE_PRINTED_IN_THE_KITCHEN = 16 // DEPRECATED in favor of Handy Actions ComparesVersions@canSendHandyActions
const REFUND = 17
// const STATUS_WAITING_EXTERNAL_PAYMENT = 18
// const STATUS_SPARRING_ID = 19

export default {
  NORMAL,
  CHECK_PRINTED,
  // REOPENED,
  PENDING_NOTE,
  // CONTENT_READY,
  // KIOSK_CALL_WAITER,
  // KIOSK_WAITING_BILL,
  // PAID_OUTSIDE,
  REFUNDED,
  PARTIALLY_REFUNDED,
  // MERGED_FROM_ONLINE,
  SHOULD_BE_PRINTED_IN_THE_KITCHEN,
  REFUND,
  // STATUS_WAITING_EXTERNAL_PAYMENT,
  // STATUS_SPARRING_ID,
}
